/* Publish by EComposer at 2024-06-13 10:00:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ot5i7ccyojm"]=  window.__ectimmers["ecom-ot5i7ccyojm"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-ot5i7ccyojm"]["glifvardi"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click(),Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId}),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ot5i7ccyojm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ot5i7ccyojm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-izrjecdwj9a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-izrjecdwj9a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2mc7p3xk9vj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2mc7p3xk9vj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-newaylziyte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-newaylziyte', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urq45bmu22').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urq45bmu22', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-nlqukmmgm6"]=  window.__ectimmers["ecom-nlqukmmgm6"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-nlqukmmgm6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nlqukmmgm6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pnr0av1xder').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pnr0av1xder', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fumblfask6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fumblfask6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-24bhy2tj347').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-24bhy2tj347', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kfouna6jgsi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kfouna6jgsi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16rmi90kedy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16rmi90kedy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfnc36p8mb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfnc36p8mb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-esvagscapio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-esvagscapio', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z361o5gbp28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z361o5gbp28', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gtw62nky5jn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gtw62nky5jn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zzcrbb9twc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zzcrbb9twc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f5foj5xyhed').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f5foj5xyhed', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhi92apaxzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhi92apaxzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dn1u7ip5r2g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dn1u7ip5r2g', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-k1xfjtronzo"]=  window.__ectimmers["ecom-k1xfjtronzo"] || {};
const e=this.$el;if(!e||!this.isLive)return;const i=e.querySelector(".element__featured--wrapper-list");if(i){let t={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-t.x;i.scrollLeft=t.left-a},s=function(){i.removeEventListener("mousemove",n),i.removeEventListener("mouseup",s),i.style.cursor="default",i.style.removeProperty("user-select")},o=function(r){i.style.cursor="grabbing",i.style.userSelect="none",t={left:i.scrollLeft,top:i.scrollTop,x:r.clientX,y:r.clientY},i.addEventListener("mousemove",n),i.addEventListener("mouseup",s)};i.addEventListener("mousedown",o),i.addEventListener("mouseleave",s)}

                    });
                    
                        document.querySelectorAll('.ecom-k1xfjtronzo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k1xfjtronzo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dcdsoj2cpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dcdsoj2cpj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qga024mt0ob').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qga024mt0ob', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6q25ee96u4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6q25ee96u4j', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8xsefx6ixla"]=  window.__ectimmers["ecom-8xsefx6ixla"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-8xsefx6ixla').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xsefx6ixla', settings: {"source":"vimeo"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-smg644kopbp"]=  window.__ectimmers["ecom-smg644kopbp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-smg644kopbp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-smg644kopbp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iwh1b3r5s6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iwh1b3r5s6', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4smh1elh1xu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4smh1elh1xu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0so57sl26cop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0so57sl26cop', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tzz8gh3vcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tzz8gh3vcm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hnq6pex8usk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hnq6pex8usk', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sgb26bdr6pa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sgb26bdr6pa', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y0l9res1bf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y0l9res1bf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r9dst7r2iq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r9dst7r2iq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-asxyf6ihw97"]=  window.__ectimmers["ecom-asxyf6ihw97"] || {};
if(!this.$el||!window.EComModal)return;let e=this.$el.querySelectorAll("[ecom-modal]");e.length&&new window.EComModal(e,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-asxyf6ihw97').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asxyf6ihw97', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wctqmb4o02s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wctqmb4o02s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d5tusca52pq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5tusca52pq', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}